import React from 'react';
import { Navigate, useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

import { ResetPasswordLayout } from '@thinknet-gmbh/platform-common-ui';
import { PlatformModulesEnum } from '@thinknet-gmbh/platform-common';

import { useAuthAxiosInstance } from 'src/pages/auth/auth.axios.instance/';
import { useRouteQuery } from 'src/common/helpers';
import { AUTH_SUB_PAGES } from 'src/pages/auth/auth.constants';
import { ROUTES, SUB_ROUTES } from 'src/components/app/app-routes.constants';

const ResetPassword: React.FC = () => {
  const { t } = useTranslation(['auth', 'common']);
  const navigate = useNavigate();

  const query = useRouteQuery();
  const token: string = query.get('token') || '';

  const { resetPassword } = useAuthAxiosInstance({ externalAccessToken: token });

  if (!token) {
    return <Navigate to={{ pathname: `${ROUTES.auth}/${AUTH_SUB_PAGES.verification}` }} />;
  }

  return (
    <ResetPasswordLayout
      t={t}
      resetPassword={resetPassword}
      module={PlatformModulesEnum.YUU_HR_MODULE}
      navigate={() => navigate(SUB_ROUTES.authVerification)}
    />
  );
};

export default ResetPassword;
